export const SUPPORTS_ARRAY_PROTOTYPE_FILTER = "filter" in Array.prototype;
